import React, { useState, useEffect } from 'react';
import * as ReactBootStrap from "react-bootstrap";
import { useSearchParams } from 'react-router-dom';
import { Card,Button } from 'react-bootstrap';
import {createUserWithEmailAndPassword,
onAuthStateChanged,
signOut,
sendPasswordResetEmail} from "firebase/auth";
import {auth} from "../../firebase-config";
import {db} from "../../firebase-config";
import {app} from "../../firebase-config";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";
import { async } from '@firebase/util';
import Dialog from "./Dialog";
import Cookies from 'universal-cookie';
import DatePicker from "react-datepicker";
import PlayersFormModule from './playerform.module';
import PlayerList from './playerlist.module';
import PlayerInfo from './playerinfo.module';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
// export default class Login extends Component {
const PlayersModule = (user) => {
    // console.log(user);
    const cookies = new Cookies();
    const [module,setModule] = useState(0);
    const [player_name,setPlayerName] = useState("");
    const [action,setAction] = useState("");
    const [player,setPlayer] = useState([]);

    // cookies.set('player', "none", { path: '/' });
    let [searchParams, setSearchParams] = useSearchParams();
    const updateAssignedProgram = async () => {
      const userDoc = doc(db, "assignedprograms", searchParams.get("uid"));
      var date = new Date();
      const newFields = { 
        date_paid:date,
        status: "Paid" };
      await updateDoc(userDoc, newFields).then(()=>{
        updatePlayerProgram();
      });
    }

    const updatePlayerProgram = async () => {
      const userDoc = doc(db, "players",  cookies.get('player'));
      const newFields = { 
        active_program:"1",
        program_name: searchParams.get("program_name") };
      await updateDoc(userDoc, newFields).then(()=>{
        updateState(1);
      });
    }

    useEffect(() => {
      if(cookies.get('player_name')){
        setPlayerName(cookies.get('player_name'));
      }
      if(searchParams.get("r")=="yes"){
        updateAssignedProgram();
      }
      if(searchParams.get("r")=="no"){
        updateState(1);
      }
      if(searchParams.get("r")=="addplayer"){
        updateState(2);
      }
      if(searchParams.get("event")=="signing_complete"){
        updateProgram();
      }
      if(searchParams.get("event")=="ttl_expired"){
        updateState(1);
      }
    }, []) 

    const updateProgram = async () =>{
      const userDoc = doc(db, "assignedprograms", searchParams.get("programid"));
      const newFields = {envelopeCompleted: "Completed"};
      await updateDoc(userDoc, newFields).then(()=>{
        updateState(1);
      });
    }

    const updateState = (name) => {
      setModule(name);
      setAction("Register New Player");
    }

    const updateStatePlayer = (name,player_name,player) => {
      if(name==2){
        setAction("Modify Player");
      }
      setPlayer(player);
      setPlayerName(player_name);
      cookies.set('player_name', player_name, { path: '/' });
      setModule(name);
    }
    // user.userHome.user.email <- getting users
    // console.log(user);
    return (
      <>
        <Tabs selectedIndex={module}>
          <TabList>
            <Tab onClick={()=>{updateState(0);}}>Players List</Tab>
            <Tab onClick={()=>{updateState(1)}}>Player Information<b> {player_name}</b></Tab>
            <Tab onClick={()=>{updateState(2);}}>Add New Player</Tab>
          </TabList>
          <TabPanel>
            {(module===0)?<PlayerList userHome={user}  updateStatePlayer={updateStatePlayer}/>:"" }
          </TabPanel>
          <TabPanel>
            {(module===1)?<PlayerInfo userHome={user}  updateStatePlayer={updateStatePlayer}/>:"" }
          </TabPanel>
          <TabPanel>
            {(module===2)?<PlayersFormModule userHome={user}  updateStatePlayer={updateStatePlayer} action={action} player={player}/>:"" }
          </TabPanel>
        </Tabs>
      </>
    )
  // }
}

export default PlayersModule;